const moneyFormatter = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: window.Shopify?.currency?.active || 'USD',
  maximumFractionDigits: 0
});

const formatMoney = (cents) => moneyFormatter.format(Math.round(Number(cents || 0) / 100));

const getCheckedValues = (form, group) => {
  return Array.from(form.querySelectorAll(`[data-caseere-filter="${group}"]:checked`)).map((input) => input.value);
};

const hasAnyToken = (source, values) => {
  if (!values.length) return true;
  const tokens = String(source || '').split(/\s+/).filter(Boolean);
  return values.some((value) => tokens.includes(value));
};

const setTokens = (tokens) => Array.from(new Set(tokens.filter(Boolean))).join(' ');

const normalizeProductTypeData = (cards) => {
  cards.forEach((card) => {
    const sizes = String(card.dataset.caseereSizes || '').split(/\s+/).filter(Boolean);
    const currentTypes = String(card.dataset.caseereProductTypes || '').split(/\s+/).filter(Boolean);
    const title = String(card.textContent || '').toLowerCase().replace(/\s+/g, ' ');
    const path = window.location.pathname;
    let types = currentTypes.filter((type) => !type.startsWith('airpods-') && type !== 'airpods-case');
    if (!path.includes('/collections/leather-phone-case') && !path.includes('/collections/all')) {
      types = types.filter((type) => type !== 'wallet-case');
    }
    const hasAirpodsModel = sizes.some((size) => size.startsWith('airpods'));

    if (hasAirpodsModel) {
      types.push('airpods-case');
      if (sizes.includes('airpods-1-2')) types.push('airpods-1-2-case');
      if (sizes.includes('airpods-3')) types.push('airpods-3-case');
      if (sizes.includes('airpods-4')) types.push('airpods-4-case');
      if (sizes.some((size) => size.startsWith('airpods-pro'))) types.push('airpods-pro-case');
      if (sizes.includes('airpods-pro-2')) types.push('airpods-pro-2-case');
      if (sizes.includes('airpods-pro-3')) types.push('airpods-pro-3-case');
      if (sizes.includes('airpods-max')) types.push('airpods-max-case');
    }

    if (path.includes('/collections/ipad-macbook-sleeve') || path.includes('/collections/all')) {
      if (sizes.some((size) => size.includes('ipad'))) types.push('ipad-sleeve');
      if (sizes.some((size) => size.includes('macbook'))) types.push('macbook-sleeve');
    }

    if (path.includes('/collections/bag') || path.includes('/collections/all')) {
      if (title.includes('phone bag')) types.push('phone-bag');
      if (title.includes('sling bag')) types.push('sling-bag');
      if (title.includes('bucket bag')) types.push('bucket-bag');
      if (title.includes('backpack')) types.push('backpack');
      if (title.includes('tote')) types.push('tote-bag');
      if (title.includes('wallet')) types.push('wallet');
    }

    if (path.includes('/collections/wallet') || path.includes('/collections/all')) {
      if (title.includes('wallet')) types.push('wallet');
      if (title.includes('cash wrap')) types.push('cash-wrap-wallet');
      if (title.includes('snap wallet')) types.push('snap-wallet');
      if (title.includes('coin purse')) types.push('coin-purse');
      if (title.includes('money clip')) types.push('money-clip-wallet');
      if (title.includes('key holder')) types.push('key-holder');
      if (title.includes('passport holder')) types.push('passport-holder');
    }

    if (path.includes('/collections/all')) {
      if (title.includes('luggage tag')) types.push('luggage-tag');
      if (title.includes('watch strap')) types.push('watch-strap');
      if (title.includes('wallet') && (title.includes('iphone') || title.includes('samsung') || title.includes('galaxy'))) types.push('wallet-case');
      if (title.includes('strap') && (title.includes('iphone') || title.includes('samsung') || title.includes('galaxy'))) types.push('wallet-case');
    }

    card.dataset.caseereProductTypes = setTokens(types);
  });
};

const syncProductTypeCounts = (form, cards) => {
  form.querySelectorAll('[data-caseere-filter="product-type"]').forEach((input) => {
    const count = cards.filter((card) => hasAnyToken(card.dataset.caseereProductTypes, [input.value])).length;
    const label = input.closest('label');
    const countEl = label?.querySelector('.caseere-phone-filter__count');
    if (countEl) countEl.textContent = String(count);
    if (label) label.hidden = count === 0;
  });
};

const normalizeSeriesData = (cards) => {
  if (!window.location.pathname.includes('/collections/all')) return;

  cards.forEach((card) => {
    const sizes = String(card.dataset.caseereSizes || '').split(/\s+/).filter(Boolean);
    const title = String(card.textContent || '').toLowerCase().replace(/\s+/g, ' ');
    const series = String(card.dataset.caseereSeries || '').split(/\s+/).filter(Boolean);

    if (title.includes('iphone') || title.includes('samsung') || title.includes('galaxy')) {
      series.push('leather-phone-case');
    }
    if (sizes.some((size) => size.startsWith('airpods')) || title.includes('airpods') || title.includes('powerbeats') || title.includes('beats studio')) {
      series.push('leather-airpods-case');
    }
    if (sizes.some((size) => size.includes('ipad') || size.includes('macbook')) || title.includes('sleeve')) {
      series.push('ipad-macbook-sleeve');
    }
    if (title.includes('phone bag') || title.includes('sling bag') || title.includes('bucket bag') || title.includes('backpack') || title.includes('tote')) {
      series.push('bag');
    }
    if (title.includes('wallet') || title.includes('cash wrap') || title.includes('coin purse') || title.includes('money clip') || title.includes('key holder') || title.includes('passport holder')) {
      series.push('wallet');
    }
    if (title.includes('luggage tag') || title.includes('watch strap')) {
      series.push('accessories');
    }

    card.dataset.caseereSeries = setTokens(series);
  });
};

const initPhoneCaseFilters = (form) => {
  if (form.dataset.caseereReady === 'true') return;
  form.dataset.caseereReady = 'true';

  const cards = Array.from(document.querySelectorAll('[data-caseere-phone-card]'));
  normalizeProductTypeData(cards);
  normalizeSeriesData(cards);
  syncProductTypeCounts(form, cards);
  const empty = document.querySelector('[data-caseere-phone-empty]');
  const minInput = form.querySelector('[data-caseere-price-min]');
  const maxInput = form.querySelector('[data-caseere-price-max]');
  const minLabel = form.querySelector('[data-caseere-price-min-label]');
  const maxLabel = form.querySelector('[data-caseere-price-max-label]');
  const fill = form.querySelector('[data-caseere-price-fill]');
  const rangeMin = Number(form.dataset.minPrice || 0);
  const rangeMax = Number(form.dataset.maxPrice || 0);

  const updateRange = () => {
    if (!minInput || !maxInput) return;
    let minValue = Number(minInput.value);
    let maxValue = Number(maxInput.value);

    if (minValue > maxValue) {
      if (document.activeElement === minInput) {
        maxValue = minValue;
        maxInput.value = String(maxValue);
      } else {
        minValue = maxValue;
        minInput.value = String(minValue);
      }
    }

    if (minLabel) minLabel.textContent = formatMoney(minValue);
    if (maxLabel) maxLabel.textContent = formatMoney(maxValue);

    if (fill && rangeMax > rangeMin) {
      const minPercent = ((minValue - rangeMin) / (rangeMax - rangeMin)) * 100;
      const maxPercent = ((maxValue - rangeMin) / (rangeMax - rangeMin)) * 100;
      fill.style.left = `${Math.max(0, Math.min(100, minPercent))}%`;
      fill.style.right = `${Math.max(0, 100 - Math.min(100, maxPercent))}%`;
    }
  };

  const applyFilters = () => {
    updateRange();

    const availability = getCheckedValues(form, 'availability');
    const colors = getCheckedValues(form, 'color');
    const sizes = getCheckedValues(form, 'size');
    const styles = getCheckedValues(form, 'style');
    const productTypes = getCheckedValues(form, 'product-type');
    const series = getCheckedValues(form, 'series');
    const minPrice = minInput ? Number(minInput.value) : rangeMin;
    const maxPrice = maxInput ? Number(maxInput.value) : rangeMax;
    let visibleCount = 0;

    cards.forEach((card) => {
      const available = card.dataset.caseereAvailable === 'true';
      const priceMin = Number(card.dataset.caseerePriceMin || 0);
      const priceMax = Number(card.dataset.caseerePriceMax || priceMin);

      const matchesAvailability = !availability.length
        || (availability.includes('in-stock') && available)
        || (availability.includes('out-of-stock') && !available);
      const matchesPrice = priceMax >= minPrice && priceMin <= maxPrice;
      const matchesColor = hasAnyToken(card.dataset.caseereColors, colors);
      const matchesSize = hasAnyToken(card.dataset.caseereSizes, sizes);
      const matchesStyle = hasAnyToken(card.dataset.caseereStyles, styles);
      const matchesType = hasAnyToken(card.dataset.caseereProductTypes, productTypes);
      const matchesSeries = hasAnyToken(card.dataset.caseereSeries, series);
      const visible = matchesAvailability && matchesPrice && matchesColor && matchesSize && matchesStyle && matchesType && matchesSeries;

      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (empty) empty.hidden = visibleCount !== 0;
  };

  form.addEventListener('change', applyFilters);
  form.addEventListener('input', applyFilters);
  applyFilters();
};

document.querySelectorAll('[data-caseere-phone-filters]').forEach(initPhoneCaseFilters);
document.addEventListener('shopify:section:load', () => {
  document.querySelectorAll('[data-caseere-phone-filters]').forEach(initPhoneCaseFilters);
});
